import { createSlice } from "@reduxjs/toolkit";
import {
    fetchPracticeInfoDetails,
    fetchPracticeInfoPhoneFaxDetails,
    fetchPracticeInfoEmailDetails,
    fetchUpdatePracticeInfoEmailDetailsAPI,
    fetchUpdatePracticeInfoPhoneFaxDetails,
    fetchUpdatePracticeInfoDetailsAPI
} from "./PracticeInfoActions";
import { getApiErrorMessage } from "../../utils/commonUtilities";


const practiceInfoDetails = createSlice({
    name: "practiceInfoDetails",
    initialState: {
        isPracticeInfoDataLoading: false,
        practiceInfoDetails: {},
        practiceInfoDataError: null,
        practiceInfoDataErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPracticeInfoDetails.pending, (state) => {
                state.isPracticeInfoDataLoading = true;
                state.practiceInfoDataError = null;
            })
            .addCase(fetchPracticeInfoDetails.fulfilled, (state, action) => {
                state.isPracticeInfoDataLoading = false;
                if (action?.payload && !action?.payload?.success) {
                    if (action.payload.data.metadata?.outcome.additionalDetails[0]
                        ?.additionalInfo) {
                        state.practiceInfoDataError = false;
                        state.practiceInfoDetails = {};
                    }
                    else {
                        state.practiceInfoDataError = true;
                        state.practiceInfoDataErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.practiceInfoDataError = false;
                    state.practiceInfoDetails = action?.payload?.data?.data?.practiceExtendedResponseDTO;
                }
            })
            .addCase(fetchPracticeInfoDetails.rejected, (state, action) => {
                state.isPracticeInfoDataLoading = false;
                state.practiceInfoDataError = action.error.message;
            })
            .addCase(fetchUpdatePracticeInfoDetailsAPI.pending, (state) => {
                state.isPracticeInfoDataLoading = true;
                state.practiceInfoDataError = null;
            })
            .addCase(fetchUpdatePracticeInfoDetailsAPI.fulfilled, (state, action) => {
                state.isPracticeInfoDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.practiceInfoDataError = false;
                        state.practiceInfoDetails = {};
                    }
                    else {
                        state.practiceInfoDataError = true;
                        state.practiceInfoDataErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.practiceInfoDetails = action.payload.data.data.practiceExtendedResponseDTO;
                }
            })
            .addCase(fetchUpdatePracticeInfoDetailsAPI.rejected, (state, action) => {
                state.isPracticeInfoDataLoading = false;
                state.practiceInfoDataError = action.error.message;
            })
    },
});



const practiceInfoPhoneFaxDetails = createSlice({
    name: "practiceInfoPhoneFaxDetails",
    initialState: {
        isPhoneFaxDataLoading: false,
        practiceInfoPhoneFaxDetails: [],
        phoneFaxDataError: null,
        phoneFaxDataErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPracticeInfoPhoneFaxDetails.pending, (state) => {
                state.isPhoneFaxDataLoading = true;
                state.phoneFaxDataError = null;
            })
            .addCase(fetchPracticeInfoPhoneFaxDetails.fulfilled, (state, action) => {
                state.isPhoneFaxDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.phoneFaxDataError = false;
                        state.practiceInfoPhoneFaxDetails = [];
                    }
                    else {
                        state.phoneFaxDataError = true;
                        state.phoneFaxDataErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.phoneFaxDataError = false;
                    const phoneFaxData = [];
                    const fetchData = action.payload.data.data.practicePhoneFaxResponseDTO;
                    fetchData.map((item) => {
                        const displayId = Date.now().toString(20) + Math.random().toString(20).substring(2, 5);
                        const defaultValues = {
                            number: item.number,
                            isValid: item.isValid,
                            phoneType: item.phoneType,
                            contactType: item.contactType || "",
                            displayId
                        }
                        phoneFaxData.push(defaultValues)
                    })
                    state.practiceInfoPhoneFaxDetails = phoneFaxData;
                }
            })
            .addCase(fetchPracticeInfoPhoneFaxDetails.rejected, (state, action) => {
                state.isPhoneFaxDataLoading = false;
                state.phoneFaxDataError = action.error.message;
            })
            .addCase(fetchUpdatePracticeInfoPhoneFaxDetails.pending, (state) => {
                state.isPhoneFaxDataLoading = true;
                state.phoneFaxDataError = null;
            })
            .addCase(fetchUpdatePracticeInfoPhoneFaxDetails.fulfilled, (state, action) => {
                state.isPhoneFaxDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.phoneFaxDataError = false;
                        state.practiceInfoPhoneFaxDetails = [];
                    }
                    else {
                        state.phoneFaxDataError = true;
                        state.phoneFaxDataErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.practiceInfoPhoneFaxDetails = action.payload.data.data.practicePhoneFaxResponseDTO;
                }
            })
            .addCase(fetchUpdatePracticeInfoPhoneFaxDetails.rejected, (state, action) => {
                state.isPhoneFaxDataLoading = false;
                state.phoneFaxDataError = action.error.message;
            })
    },
});


const practiceInfoEmailDetails = createSlice({
    name: "practiceInfoEmailDetails",
    initialState: {
        isEmailDataLoading: false,
        practiceInfoEmailDetails: [],
        emailDataError: null,
        emailDataErrorMsg: ""
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchPracticeInfoEmailDetails.pending, (state) => {
                state.isEmailDataLoading = true;
                state.emailDataError = null;
            })
            .addCase(fetchPracticeInfoEmailDetails.fulfilled, (state, action) => {
                state.isEmailDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.emailDataError = false;
                        state.practiceInfoEmailDetails = [];
                    }
                    else {
                        state.emailDataError = true;
                        state.emailDataErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.emailDataError = false;
                    const emailData = [];
                    const fetchData = action.payload.data.data.practiceEmailResponseDTO;
                    fetchData.map((item) => {
                        const displayId = Date.now().toString(20) + Math.random().toString(20).substring(2, 5);
                        const defaultValues = {
                            email: item.email,
                            isValid: item.isValid,
                            contactType: item.contactType || "",
                            displayId
                        }
                        emailData.push(defaultValues)
                    })
                    state.practiceInfoEmailDetails = emailData;
                }
            })
            .addCase(fetchPracticeInfoEmailDetails.rejected, (state, action) => {
                state.isEmailDataLoading = false;
                state.emailDataError = action.error.message;
            })
            .addCase(fetchUpdatePracticeInfoEmailDetailsAPI.pending, (state) => {
                state.isEmailDataLoading = true;
                state.emailDataError = null;
            })
            .addCase(fetchUpdatePracticeInfoEmailDetailsAPI.fulfilled, (state, action) => {
                state.isEmailDataLoading = false;
                if (!action.payload.success) {
                    if (
                        action.payload.data.metadata?.outcome.additionalDetails[0]
                            ?.additionalInfo
                    ) {
                        state.emailDataError = false;
                        state.practiceInfoEmailDetails = [];
                    }
                    else {
                        state.emailDataError = true;
                        state.emailDataErrorMsg = getApiErrorMessage(action.payload.status);
                    }
                } else {
                    state.emailDataError = false;
                    state.practiceInfoEmailDetails = action.payload.data.data.practiceEmailResponseDTO;
                }
            })
            .addCase(fetchUpdatePracticeInfoEmailDetailsAPI.rejected, (state, action) => {
                state.isEmailDataLoading = false;
                state.emailDataError = action.error.message;
            });
    },
});



export const { updatePracticeInfoDetails } = practiceInfoDetails.actions;
export const practiceInfoDetailsReducer = practiceInfoDetails.reducer;

export const { updatePracticeInfoPhoneFaxDetails } = practiceInfoPhoneFaxDetails.actions;
export const practiceInfoPhoneFaxDetailsReducer = practiceInfoPhoneFaxDetails.reducer;

export const { updatePracticeInfoEmailDetails } = practiceInfoEmailDetails.actions;
export const practiceInfoEmailDetailsReducer = practiceInfoEmailDetails.reducer;